class VideoElement extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.video = this.querySelector('video');
    this.posterDiv = this.querySelector('.video-element__video-img');

    if (!this.video || !this.posterDiv) return;

    this.posterDiv.addEventListener('click', () => {
      document.querySelectorAll('video-element').forEach(el => {
        if (el !== this && el.video && !el.video.paused) {
          el.video.pause();
          el.classList.remove('is-playing');
        }
      });

      this.classList.add('is-playing');
      this.video.play();
    });

    this.video.addEventListener('click', () => {
      if (!this.video.paused) {
        this.video.pause();
        this.classList.remove('is-playing');
      }
    });
  }
}

customElements.define('video-element', VideoElement);